import { render } from "./chat-right-video.vue?vue&type=template&id=644a4a1c"
import script from "./chat-right-video.vue?vue&type=script&lang=js"
export * from "./chat-right-video.vue?vue&type=script&lang=js"

import "./chat-right-video.vue?vue&type=style&index=0&id=644a4a1c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__